<script>
  import {getContext} from 'svelte';
  import {PATHS} from '@/const/paths';
  import {envUtil} from '@/helper/env';
  import {Button} from '@px/button';
  import AccessWithApple from '../../components/access-apple/AccessWithApple.svelte';
  import AccessWithGoogle from '../../components/access-google/AccessWithGoogle.svelte';
  import AccessWithTelegram from '../../components/access-telegram/AccessWithTelegram.svelte';
  import AccessWithMetaMask from '../../components/access-with-wallet/AccessWithMetaMask.svelte';
  import lang from '../HomePage.lang';

  const LG = getContext('LG');
  const loginIcon = [
    {
      component: AccessWithGoogle,
      props: {
        defaultIcon: 'https://img.phemex.com/v1/28a893a3-e0ea-46ee-bc8c-398924112ff9/home-google.png',
        hoverIcon: 'https://img.phemex.com/v1/68bfcb03-8258-42e5-8c8c-2e50316bf1c8/home-google-hover.png',
        alt: 'Google',
        visibleTitle: false,
      },
      lang,
      visible: true,
    },
    // {
    //   component: AccessWithApple,
    //   props: {
    //     defaultIcon: 'https://img.phemex.com/v1/6a85961e-d1e9-4bd5-8dbe-fe515ab92188/home-apple.png',
    //     hoverIcon: 'https://img.phemex.com/v1/4c176e1b-03cf-45b7-813b-c1eefc7e53b6/home-apple-hover.png',
    //     alt: 'Metamask',
    //     visibleTitle: false,
    //   },
    //   visible: envUtil.isMac,
    // },
    {
      component: AccessWithTelegram,
      props: {
        defaultIcon: 'https://img.phemex.com/v1/1c5a5b63-e3d9-4404-a3ef-ce8b218224f6/white-default.svg',
        hoverIcon: 'https://img.phemex.com/v1/496693ab-d81f-45e3-b09c-a5cee1f1d160/white-default-1.svg',
        alt: 'Telegram',
        visibleTitle: false,
      },
      visible: true,
    },
    {
      component: AccessWithMetaMask,
      props: {
        defaultIcon: 'https://img.phemex.com/v1/d76b3be8-d1bc-46d1-9153-2de818ff9002/home-metamask.png',
        hoverIcon: 'https://img.phemex.com/v1/8ea91bb6-5400-49e8-8cc2-47938e13cc8c/home-metamask-hover.png',
        alt: 'Metamask',
        visibleTitle: false,
      },
      visible: true,
    },
  ];

  function handleToRegister() {
    const emailDom = document.getElementById('email');
    const email = emailDom?.target?.value || emailDom?.value;
    window.open(`${PATHS.REGISTER.pathname}?account=${encodeURIComponent(email)}`, '_self', 'noopener');
  }
</script>

<style lang="scss">
  .login {
    .gap-8 {
      gap: 8px;
    }
    &-input {
      box-sizing: border-box;
      border-radius: 28px;
      padding: 4px 4px 4px 20px;
      width: 400px;
      height: 56px;
      background: #fff;
      :global(.btn-started) {
        border-radius: 28px;
        min-width: 120px;
        height: 100%;
        font-weight: 700;
      }
      input {
        display: block;
        box-sizing: border-box;
        border: none;
        padding: 10px 0;
        height: 100%;
        font-weight: 500;
        font-size: 14px;
        outline: none;
      }
    }
    &-icon-button {
      display: flex;
      gap: 12px;
      img {
        display: inline-block;
        width: auto;
        height: 56px;
      }
    }
  }
  .login :global(.wallet-connect-box) {
    width: 56px;
    height: 56px;
  }
  .login :global(.wallet-connect-box > div) {
    border: unset;
    border-radius: 28px;
    width: 56px;
    height: inherit;
  }
  .login :global(.wallet-connect-box > div .img) {
    border: unset;
    width: unset;
    height: unset;
  }
  .login :global(.wallet-connect-box > div .img img) {
    width: 56px;
    height: 56px;
  }
  .login :global(.wallet-connect-box >div:hover .img) {
    background: unset;
  }
  .login :global(.wallet-connect-box >div:hover .img) {
    background: unset;
  }
</style>

<div class="login mt12" on:click|stopPropagation>
  <div class="df jcsb aic gap-8 login-input">
    <input class="f1" id="email" autocomplete="off" type="email" placeholder={LG(lang.UserName)} />
    <Button class="btn-started" on:click={handleToRegister}>{LG(lang.GetStarted)}</Button>
  </div>
  <div class="mt24 login-icon-button">
    {#each loginIcon as item}
      {#if item.visible}
        <svelte:component this={item.component} width="56" lang={item.lang} iconInfo={item.props} scene="login"/>
      {/if}
    {/each}
  </div>
</div>
